import React, { useState, useCallback, useEffect } from "react"
import Typography from "aldoo-ra/Typography"
import { showNotification } from "aldoo-ra/Notification"
import { PermissionsPlatformAPI } from "./permissions-api"
import ResourceDefinitionsTab from "./components/ResourceDefinitionsTab"
import UserPermissionsTab from "./components/UserPermissionsTab"

/**
 * Main Permissions Manager Component
 * Displays both Resource Definitions and User Permissions side by side
 */
const PermissionsManager = () => {
  const [loading, setLoading] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0)

  // Global refresh function
  const handleRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1)
  }, [])

  // Global error handler
  const handleError = useCallback((errorMessage) => {
    showNotification({
      message: errorMessage,
      className: "bg-admin_error text-white",
      duration: 4000
    })
  }, [])

  return (
    <div className="p-6">
      {/* Side by Side Tables */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        {/* Left - Resource Definitions */}
        <div className="bg-admin_paper rounded-3xl p-6">
          <Typography 
            component="h2"
            variant="admin_h4"
          >
            Permissions
          </Typography>

          <ResourceDefinitionsTab
            refreshKey={refreshKey}
            onRefresh={handleRefresh}
            onError={handleError}
            loading={loading}
            setLoading={setLoading}
          />
        </div>

        {/* Right - User Permissions */}
        <div className="bg-admin_paper rounded-3xl p-6">
          <div className="flex items-center gap-2 mb-4">
            <Typography 
              component="h2"
              variant="admin_h4" 
            >
              User Permissions
            </Typography>
          </div>

          <UserPermissionsTab
            refreshKey={refreshKey}
            onRefresh={handleRefresh}
            onError={handleError}
            loading={loading}
            setLoading={setLoading}
          />
        </div>
      </div>
    </div>
  )
}

export default PermissionsManager